import axiosInstance from "./axiosConfig";
import {ReactData} from "./FrontendDataTypes";

const ISO_INSTANT =
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,9})?(?:Z|[+\-]\d{2}:\d{2})$/;

// Type Guard: prüft, ob ein Wert ein String ist, der wie ein ISO-Timestamp aussieht
function isIsoTimestamp(value: unknown): value is string {
    return typeof value === "string" && ISO_INSTANT.test(value);
}

// Hauptfunktion: wandelt alle ISO-Timestamps in Date-Objekte um (rekursiv)
export function reviveApiDates<T>(obj: T): T {
    // 1) Wenn schon ein Date-Objekt: so zurückgeben
    if (obj instanceof Date) return obj;

    // 2) Wenn ein Array: jedes Element rekursiv bearbeiten
    if (Array.isArray(obj)) {
        return obj.map(reviveApiDates) as unknown as T;
    }

    // 3) Wenn ein Objekt: alle Schlüssel/Werte rekursiv bearbeiten
    if (obj !== null && typeof obj === "object") {
        const out: Record<string, unknown> = {};
        for (const [k, v] of Object.entries(obj as Record<string, unknown>)) {
            out[k] = reviveApiDates(v);
        }
        return out as T;
    }

    // 4) Wenn ein ISO-Timestamp-String: in echtes Date konvertieren
    if (isIsoTimestamp(obj)) {
        return new Date(obj) as unknown as T;
    }

    // 5) Alles andere (Zahlen, "normale" Strings wie Straße/PLZ, booleans etc.) unverändert lassen
    return obj;
}

export const data = async () : Promise<ReactData> => {
    const response = await axiosInstance.get('/data');

    if (response.status !== 200) {
        return Promise.reject("Request, failed")
    }

    return reviveApiDates(response.data);

}